import React from "react";
import { asField } from "informed";
import { isEmpty } from "lodash";

import { SimpleSelectInput } from "./index";
import validatehoc from "../Validator";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class OAuthPicker extends React.Component {
	constructor(props) {
		super(props);
		this.appKey = parseAppKey();
		this.state = {
			// data
			integrations: [],
			// oauth data
			oauthIntegrationId: null,
			// flags
			loading: false,
			hasPickedOAuthIntegration: false,
			// errors
			errorGettingIntegrations: null,
		};
	}

	componentDidMount() {
		let { integrationTypes, initialValue } = this.props;
		let initialState = {};

		this.setState({ loading: true }, async () => {
			const integrations = await this.getOAuthIntegrations(integrationTypes);
			if (integrations.errorGettingIntegrations) {
				initialState = {
					...initialState,
					errorGettingIntegrations: integrations.errorGettingIntegrations,
				};
			} else {
				initialState = {
					...initialState,
					integrations,
				};
			}

			if (!isEmpty(initialValue)) {
				Object.keys(initialValue).forEach(property => {
					initialState[property] = initialValue[property];
				});
				if (initialValue.oauthIntegrationId) {
					initialState.hasPickedOAuthIntegration = true;
				}
			}

			this.setState({ loading: false, ...initialState });
		});
	}

	getOAuthIntegrations = async integrationTypes => {
		let response = null;
		try {
			const data = await GetItem(`/apps/${this.appKey}/oauth`);
			response = data.data.filter(i => integrationTypes.includes(i.moduleKey));
		} catch (error) {
			response = { errorGettingIntegrations: "Error getting OAuth integrations" };
			console.warn(response.errorGettingIntegrations, error);
		}
		return response;
	};

	changeOAuthIntegration = event => {
		const oauthIntegrationId = event.target.value;
		this.setState((state, props) => {
			this.updateFormFieldValue("oauthIntegrationId", oauthIntegrationId);
			return {
				oauthIntegrationId,
				hasPickedOAuthIntegration: true,
			};
		});
	};

	updateFormFieldValue = (property, value) => {
		const { fieldApi } = this.props;

		let existingFieldValue = fieldApi.getValue();
		fieldApi.setValue({
			...existingFieldValue,
			[property]: value,
		});

		fieldApi.setTouched(true);
	};

	render() {
		const { fieldState } = this.props;
		const { integrations, oauthIntegrationId, loading, errorGettingIntegrations } = this.state;

		const { error } = fieldState;
		const hasError = error ? " has-error" : "";

		const allIntegrationsValues = integrations.map(i => ({ key: i.id, value: i.id, label: i.name }));

		const loadingOAuthIntegrations = loading && isEmpty(integrations);
		const showIntegrationPicker = !errorGettingIntegrations && !loading && !isEmpty(integrations);

		return (
			<div className={`input-wrap${hasError}`}>
				<div className="oauth-integration-picker">
					{loadingOAuthIntegrations && <small>Loading integrations...</small>}
					{errorGettingIntegrations && <small>{errorGettingIntegrations}</small>}
					{showIntegrationPicker && (
						<SimpleSelectInput
							id="oauthIntegrationId"
							placeholder="Integration"
							values={allIntegrationsValues}
							value={oauthIntegrationId || ""}
							onChange={this.changeOAuthIntegration}
						/>
					)}
				</div>
			</div>
		);
	}
}

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => {
		return <OAuthPicker fieldState={fieldState} {...props} />;
	}),
	"oauth"
);

export default Wrapper;
